module.exports = __webpack_public_path__ + "static/media/imgs_100.be79a165.jpg";